const config = {
    prefix: 'ELEMENCAST',
    development: 'http://localhost:8080',
    stage: '',
    production: 'https://elemencast.github.io'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js